import AxL from "../js/axl.js";
export default class Artwork {
  constructor(json, scope, _p) {
    console.log(json);
    this.scope = scope;
    const parent = _p || scope.template;
    this.isLoaded = false;
    this.asset_id = json.id;
    this.img = parent.getElementsByTagName("img")[0];
    this.img.onload = this.onLoaded.bind(this);
    this.img.src =
      json.parsed.thumbnail.replace("http://", "https://") + "=w300";
    this.img.style.cursor = "pointer";
    this.title = parent.getElementsByClassName("artwork_title")[0];
    this.author = parent.getElementsByClassName("artwork_author")[0];
    this.collection = parent.getElementsByClassName("artwork_collection")[0];
    this.learnMore = parent.getElementsByClassName("learnMoreButton")[0];
    this.close = document.getElementsByClassName("mdc-close")[0];
    this.title.textContent = json.parsed.title;
    this.author.textContent = json.parsed.creator;
    this.collection.textContent = json.parsed.collection;
    this.clickHandler = this.onImageClick.bind(this);
    this.closeHandler = this.onClose.bind(this);
    this.img.addEventListener("click", this.clickHandler);
    this.learnMore.addEventListener("click", this.clickHandler);
    this.close.addEventListener("click", this.closeHandler);
  }
  onImageClick(e) {
    if (this.scope.axl) {
      console.log("simple call with analytics");
      console.log(
        "NAVIGATE CALLS : AxL.ChildToHost.NAVIGATE",
        "asset/" + this.asset_id
      );
      this.scope.axl.sendMessage(
        AxL.ChildToHost.NAVIGATE,
        "asset/" + this.asset_id
      );
      // --> ANALYTICS
      if (this.scope.axl) {
        this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "navigate_to_asset",
          label: "asset_image / " + this.asset_id,
          value: 0,
          nonInteraction: false,
        });
      }
    }
  }
  reset() {
    this.isLoaded = false;
    this.img.removeEventListener("click", this.clickHandler);
    this.learnMore.removeEventListener("click", this.clickHandler);
    this.close.removeEventListener("click", this.closeHandler);
    this.img.src = "";
    this.title.textContent = "";
    this.author.textContent = "";
    this.collection.textContent = "";
    this.showLoader();
  }
  onLoaded(e) {
    this.isLoaded = true;
    if (this.scope.puzzle.isReady) {
      this.hideLoader();
      console.log(this.scope.USER_AMOUNT, this.scope.USER_LIMIT);

      if (
        (!this.scope.USER_AMOUNT ||
          this.scope.USER_AMOUNT < this.scope.USER_LIMIT) &&
        this.scope.GAME_STATE != "win"
      ) {
        const shareButton = document.querySelector(".shareButton");
        shareButton.classList.remove("hide");
        if (shareButton.classList.contains("transparent"))
          shareButton.classList.remove("transparent");
        const soloButton = document.querySelector(".soloButton");
        soloButton.classList.remove("hide");
      }
    }
  }
  hideLoader() {
    /* add the option to hide the learn more button */
    const loader = document.querySelector(".mdc-linear-progress");
    if (!loader.classList.contains("hide")) loader.classList.add("hide");
    if (this.learnMore.classList.contains("hide"))
      this.learnMore.classList.remove("hide");
  }
  showLoader() {
    const loader = document.querySelector(".mdc-linear-progress");
    if (loader.classList.contains("hide")) loader.classList.remove("hide");
    if (!this.learnMore.classList.contains("hide"))
      this.learnMore.classList.add("hide");
  }
  onClose(e) {
    this.scope.artworkInfo.close();
  }
}
